import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { SxHttpService } from './sxHttp.service';
import { ExternalComponent } from '../model/classes/externalComponent.class';
import { AzureFile } from '../model/interfaces/azureFile.Interface';

@Injectable()
export class ExternalComponentService {
    private serviceUrl = 'api/externalComponent';

    constructor(private http: Http, private sxHttp: SxHttpService) { }

    getAll(systemCode: string): Observable<ExternalComponent[]> {
        const url = `${this.serviceUrl}/${systemCode}`;

        return this.sxHttp.get(url).map(response => {
            const components = response.json().data;
            return components.map(component => component as ExternalComponent);
        });
    }

    get(systemCode: string, alias: string): Observable<ExternalComponent> {
        const url = `${this.serviceUrl}/${systemCode}/${alias}`;
        return this.sxHttp
            .get(url)
            .map(response => response.json().data as ExternalComponent);
    }

    getFiles(systemCode: string, alias: string): Observable<AzureFile[]> {
        const url = `${this.serviceUrl}/${systemCode}/${alias}/files`;

        return this.sxHttp.get(url).map(response => {
            const components = response.json().data;
            return components.map(component => component as AzureFile);
        });
    }

    save(request: any): Promise<ExternalComponent> {
        const url = `${this.serviceUrl}/${request.component.systemCode}/${request.component.alias}`;

        return this.sxHttp
            .post(url, request)
            .toPromise()
            .then(response => response.json().data as ExternalComponent);
    }

    delete(systemCode: string, alias: string): Promise<Boolean> {
        const url = `${this.serviceUrl}/${systemCode}/${alias}`;

        return this.sxHttp
            .delete(url)
            .toPromise()
            .then(result => result.json().data as Boolean);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/externalComponent.service.ts